import { render, staticRenderFns } from "./GetStartedHomeEight.vue?vue&type=template&id=c0916586"
import script from "./GetStartedHomeEight.vue?vue&type=script&lang=js"
export * from "./GetStartedHomeEight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports